module.exports = __webpack_public_path__ + "static/media/caret-square-down.fcfcdb39.svg";